var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78,
    height: 102,
    viewBox: "0 0 78 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8168",
    "data-name": "Rectangle 8168",
    width: 78,
    height: 102,
    transform: "translate(0.406 0.082)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6666",
    "data-name": "Mask Group 6666",
    transform: "translate(-0.406 -0.082)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32825",
    "data-name": "Group 32825",
    transform: "translate(2.998 8.909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35310",
    "data-name": "Path 35310",
    d: "M3.936,0,53.48,0,72.814,19.284l0,61.138a3.93,3.93,0,0,1-3.936,3.923H3.936A3.93,3.93,0,0,1,0,80.421V3.923A3.93,3.93,0,0,1,3.936,0Z",
    transform: "translate(0 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35311",
    "data-name": "Path 35311",
    d: "M19.418,0A19.418,19.418,0,1,1,0,19.418,19.418,19.418,0,0,1,19.418,0Z",
    transform: "translate(16.99 24.576)",
    fill: "#3d72fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_201",
    "data-name": "Union 201",
    d: "M10.421,21.649a1,1,0,0,1-1-1V12.227H1a1,1,0,0,1-1-1v-.806a1,1,0,0,1,1-1H9.421V1a1,1,0,0,1,1-1h.806a1,1,0,0,1,1,1V9.421h8.42a1,1,0,0,1,1,1v.806a1,1,0,0,1-1,1h-8.42v8.421a1,1,0,0,1-1,1Z",
    transform: "translate(25.83 33.169)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35312",
    "data-name": "Path 35312",
    d: "M13309.16,13462.353a5.162,5.162,0,0,1-5.163-5.16V13443l19.354,19.354Z",
    transform: "translate(-13250.535 -13442.998)",
    fill: "#94c1ea"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.1b93894fa59f144c7fd0f07cb81106b7.svg";
export { ForwardRef as ReactComponent };